/**
 * Created by minimus on 14.03.2015.
 */

(function($) {
  const ejLocale = (options.locale.changeLocale) ? options.locale.locale : 'en-US';
  const localeStrings = options.strings;
  $(document).ready(function() {
    let lis;
    const dm = ej.DataManager({
      url: `${ajaxurl}?action=load_blocks&sam_pro_nonce=${options.samProNonce}`,
      removeUrl: `${ajaxurl}?action=remove_block&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });

    const grid = $('#grid').ejGrid({
      dataSource: dm,
      locale: ejLocale,
      allowTextWrap: true,
      allowPaging: true,
      allowSorting: true,
      allowFiltering: true,
      filterSettings: {filterType: 'menu'},
      pageSettings: {pageSize: options.itemsPerPage},
      allowSelection: true,
      selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
      editSettings: {allowDeleting: true, showDeleteConfirmDialog : true},
      toolbarSettings: {
        showToolbar: true,
        toolbarItems: [
          ej.Grid.ToolBarItems.Delete
        ],
        customToolbarItems: [
          {templateID: '#viewMode'},
          'Refresh',
          {templateID: '#NewBlock'},
          "Edit",
          {templateID: "#TrashBlock"},
          {templateID: "#UnTrashBlock"}
        ]
      },
      toolbarClick: function (sender, args) {
        const tbarObj = $(sender.target);
        const rec = this.getSelectedRecords();
        let bid;
        if (tbarObj.hasClass("Refresh"))
          this.refreshContent();
        if(tbarObj.hasClass('Edit')) {
          if(rec.length > 0) {
            const item = rec[0].bid;
            document.location = options.editorUrl + item;
          }
        }
        else if (tbarObj.hasClass('block-to-trash') || tbarObj.hasClass('block-from-trash')) {
          const toFrom = ((tbarObj.hasClass('block-to-trash')) ? 1 : 0);
          if (rec.length > 0) {
            const trash = parseInt(rec[0].trash, 10);

            bid = parseInt(rec[0].bid, 10);
            if (trash !== toFrom) {
              $.post(ajaxurl, {
                action: 'trash_block',
                bid: bid,
                trash: toFrom,
                sam_pro_nonce: options.samProNonce
              }).done((data) => {
                const sel = parseInt(ddList.getSelectedValue(), 10);
                if (sel === 0) grid._disabledToolItems.push(lis[6]);
                else if (sel === 1) grid._disabledToolItems.push(lis[5]);
                grid.refreshContent();
              });
            }
          }
        }
      },
      create: function (args) {
        const $toolbar = $('#grid_toolbarItems');
        lis = $toolbar.find("li");
        $('.block-to-trash').parent('li').attr('title', localeStrings.moveToTrash);
        $('.block-from-trash').parent('li').attr('title', localeStrings.restoreFromTrash);
        $('li[title="viewMode"]').attr('title', localeStrings.viewMode);
        $('li[title="NewBlock"]').attr('title', localeStrings.newBlock);
        $('li[title="Edit"]').attr('title', localeStrings.edit);
        $('.Refresh').parent('li').attr('title', localeStrings.refresh);
      },
      actionComplete: function(args) {
        const $tb = $('#grid_toolbarItems');
        let li;
        li = $('#grid_delete');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_Edit');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_TrashBlock');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_UnTrashBlock');
        $tb.ejToolbar('disableItem', li);
      },
      recordClick: function(args) {
        const $tb = $('#grid_toolbarItems');
        let li;
        const recs = this.getSelectedRecords();
        const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
        li = $('#grid_delete');
        $tb.ejToolbar(action, li);
        li = $('#grid_Edit');
        $tb.ejToolbar(action, li);
        li = $('#grid_TrashBlock');
        $tb.ejToolbar(action, li);
        li = $('#grid_UnTrashBlock');
        $tb.ejToolbar(action, li);
      },
      columns: [
        {field: 'bid', headerText: localeStrings.bid, isPrimaryKey: true, textAlign: ej.TextAlign.Right, allowSorting: true, allowEditing: false, width: 100},
        {field: 'title', headerText: localeStrings.name, allowSorting: true, allowEditing: false, width: 250},
        {field: 'description', headerText: localeStrings.desc, allowSorting: true, allowEditing: false},
        {field: 'size', headerText: localeStrings.size, textAlign: ej.TextAlign.Center, width: 100},
        {field: 'stat', headerText: localeStrings.status, textAlign: ej.TextAlign.Center, allowSorting: false, allowEditing: false, allowFiltering: false, width: 100},
        {field: 'trash', headerText: 'Status', allowEditing: false, visible: false}
      ]
    }).data('ejGrid');

    const ddList = $('#view-mode').ejDropDownList({
      selectedItemIndex: 0,
      change: function (args) {
        const sel = parseInt(this.getSelectedValue(), 10);
        if (sel !== 10) {
          $('#grid').ejGrid('model.query', new ej.Query().where('trash', ej.FilterOperators.equal, sel, 10));
        }
        else {
          $('#grid').ejGrid('model.query', new ej.Query());
        }
        if (sel === 0) grid._disabledToolItems.push(lis[6]);
        else if (sel === 1) grid._disabledToolItems.push(lis[5]);
        grid.refreshContent(true);
      }
    }).data('ejDropDownList');
  });
})(jQuery);
